import React, { useEffect, useState } from "react";
import { auth, db } from "./firebase";


const TOKEN_BROKER_URL ="https://exchangewordpresscode-4tp56twtmq-uc.a.run.app";

const WordPressSSO = () => {
  const [status, setStatus] = useState("Anmeldung wird vorbereitet ...");
  const [error, setError] = useState("");

  useEffect(() => {
    const run = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");

        if (!code) {
          throw new Error("Kein SSO-Code in der URL gefunden.");
        }

        setStatus("Zugang wird geprüft ...");

        const res = await fetch(TOKEN_BROKER_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ code }),
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data?.error || "SSO fehlgeschlagen.");
        }

        setStatus("Firebase-Anmeldung läuft ...");

        const userCredential = await auth.signInWithCustomToken(data.customToken);

        const firstName = data.profile?.firstName || "";
        const displayName =
          data.profile?.displayName || firstName || "Teilnehmer/in";

        if (userCredential.user && displayName && userCredential.user.updateProfile) {
          await userCredential.user.updateProfile({ displayName });
        }

        await db.collection("users").doc(userCredential.user.uid).set(
          {
            firstName: firstName,
            displayName: displayName,
            email: data.profile?.email || "",
            wpUserId: data.profile?.wpUserId || null,
            authSource: "wordpress",
            lastSsoAt: new Date(),
          },
          { merge: true }
        );

        setStatus("Erfolgreich angemeldet. Weiterleitung ...");

        
        window.location.replace("/course-overview");
      } catch (err) {
        console.error(err);
        setError(err.message || "Unbekannter Fehler");
      }
    };

    run();
  }, []);

  if (error) {
    return (
      <div className="container mt-5">
        <h3>SSO fehlgeschlagen</h3>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <h3>Cybersecurity-App</h3>
      <p>{status}</p>
    </div>
  );
};

export default WordPressSSO;